// TODO: make type safe
import React, { MouseEvent, useContext, useRef } from 'react';
import { SearchList } from '../../view/search-list';
import { fetchPubMedTabs, fetchPubMedList, fetchPubMedSearch } from '../../view/search-list/queries';
import { PubMedItem } from '../../view/search-list/types';
import { LinkTarget, RocheUITeaser, RocheUITeaserLayout } from '@repo/roche-ui';
import { handleRocheTeaserClick } from '../../helpers/roche-teaser-tracking';
import { DateFormattingService } from '../../services/date-time-formatter';
import { RocheXXTranslationContext } from '../../contexts/translation';

export const PubMed = ({ slot }: any): JSX.Element => {
  const teaserRef = useRef<HTMLDivElement>(null);
  const translations = useContext(RocheXXTranslationContext);

  return (
    <SearchList
      slot={slot}
      tabName='category'
      pageName='page'
      queryName='query'
      searchTabs={true}
      fetchTabs={fetchPubMedTabs}
      fetchList={fetchPubMedList}
      fetchSearch={fetchPubMedSearch}
    >
      {({ items }) => (
        <>
          {items &&
            items.map((item: PubMedItem, index) => (
              <RocheUITeaser
                ref={teaserRef}
                key={`${item.publishingDate}-${index}`}
                layout={RocheUITeaserLayout.PUBMED}
                teaserOverline={DateFormattingService.formatDate(item?.publishingDate, 'dateFull', translations)}
                teaserTitle={item.title}
                teaserAuthorDescription={item.authors.replace(/,(?! )/g, ', ')}
                teaserDescription={item.description}
                teaserUrl={item.externalLink}
                target={LinkTarget.BLANK}
                onTeaserClick={(e: MouseEvent) => handleRocheTeaserClick(e, item.title, item.externalLink, teaserRef)}
              />
            ))}
        </>
      )}
    </SearchList>
  );
};
